import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-2]",
  templateUrl: "./wall-type-2.component.html",
  styleUrls: ["./wall-type-2.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType2Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // Dummy
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
      left: `M0 184.572L97.0854 242.917L97.3795 117.215L0 58.7021V184.572Z`,
      right: `M97.0854 242.917L195.247 184.7V58.7021L97.3795 117.215L97.0854 242.917Z`
    };

    return wallData[wallSide];
  }
}
